import type { QuestionMultipleData } from '@repo/types/questions/QuestionMultiple';

import { Markdown } from '@/components/ui/markdown';

interface QuestionMarkedMultipleContentProps {
  question: QuestionMultipleData;
}

export function QuestionMarkedMultipleContent(questionMarkedMultipleContentProps: QuestionMarkedMultipleContentProps) {
  const { question } = questionMarkedMultipleContentProps;
  return (
    <ul className="list-outside list-disc space-y-2 ps-4.5">
      {question.answers.map((answer) => (
        <li key={answer.id}>
          <Markdown content={answer.content} imageClassName="max-h-68 rounded-sm" videoClassName="max-h-68 rounded-sm" />
        </li>
      ))}
    </ul>
  );
}
